'use strict';

angular.module('amexReconciliationApp').filter('toString', function () {
  return function (input) {
    if (input.constructor === Array) {
      return input.join();
    } else {
      return input;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/toString.js
// module id = 559
// module chunks = 0